import { render, staticRenderFns } from "./ResellerActions.vue?vue&type=template&id=4bfb428a&"
import script from "./ResellerActions.vue?vue&type=script&lang=js&"
export * from "./ResellerActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports